import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllCandidatesForInterviewThunk,
  getCandidatesForDecisionCenterThunk,
  getJobPositionsThunk,
} from '../../store/thunks/InterviewThunk';
import {
  Search,
  ChevronDown,
  X,
  ChevronsRight,
  ChevronsLeft,
  SlidersHorizontal,
  ArrowUpAZ,
  ArrowDownZA,
  ArrowUp10,
  ArrowDown10,
  XCircleIcon,
  ArrowUpDown,
  FileDown,
  Layout,
  Download,
  EllipsisIcon,
  EllipsisVertical,
  XIcon,
  SortAscIcon,
  Lock,
} from 'lucide-react';
import * as XLSX from 'xlsx';
import Loader from '../Loader';
import LimitExceededModal from './LimitExceededModal';
import { Dialog, Modal, useMediaQuery } from '@mui/material';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  buildInterviewThunkParams,
  deleteInterviewCandidateDataService,
  reSchedulecandidateInterviewService,
  updateCandidateStatusService,
} from '../../Services/interviewManagement.service';
import {
  addCandidateToRejectedList,
  addCandidateToShortListedList,
  removeCandidateFromInterviewLists,
  reSchedulecandidateInterview,
  selectAllCandidateFromInterViewList,
  selectCandidateFromInterViewList,
  setCandidateForReport,
  sortInterviewColByDir,
  updateCandidateStatus,
} from '../../store/slices/InterviewManagementSlice';
import ConfirmationDialog from './ConfirmationDialog';
import Pagination from './Pagination';
import { useTheme } from '../../hooks/useTheme';
import DateRangePicker from '../DatePicker';
import DropDownWithSearch from '../shared/DropDownWIthSearch';
import axios from 'axios';
import Cookies from 'js-cookie';
import host from '../../global';
import Slider from 'rc-slider';
import {
  addcandidateToSelectedList,
  toggleSchedulePopupState,
  toggleSelectAllState,
  unselectAllCandidatesReducer,
  updateSelectAllCandidateReducer,
} from '../../store/slices/candidateManagementSlice';
import ScheduleInterviewDialog from './ScheduleInterviewDialog';
import {
  resetApplyNow,
  triggerApply,
} from '../../store/slices/filterOptionsSlice';

const formatDateOnly = (date) => {
  if (!date) return null;
  return String(date).split('T')[0];
};

function InterviewManagementTable() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [interviewDateRange, setInterviewDateRange] = useState([]);

  //========================= Redux Data Filtering Starts here ==================================
  const isSchedulePopupOpen = useSelector(
    (state) => state.candidateManagementSlice.isSchedulePopupOpen,
  );

  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  console.log('rerendered');
  const dateRange = useSelector((state) => state.filterSlice.dateRange);
  const filterState = useSelector((state) => state.filterSlice);
  const sortConfig = useSelector(
    (state) => state.interviewManagementSlice.sortConfig,
  );

  const scheduledCandidates = useSelector(
    (state) => state.interviewManagementSlice.scheduledCandidates, // ← no filterByDateRange
  );
  const inProgressCandidates = useSelector(
    (state) => state.interviewManagementSlice.inProgressCandidates,
  );
  const completedCandidates = useSelector(
    (state) => state.interviewManagementSlice.completedCandidates,
  );

  const candidates = useSelector((state) => {
    const slice = state.interviewManagementSlice;
    switch (activeSubTab) {
      case 'ALL':
        return [
          ...slice.scheduledCandidates,
          ...slice.inProgressCandidates,
          ...slice.completedCandidates,
        ];
      case 'SCHEDULED':
        return slice.scheduledCandidates;
      case 'PROGRESS':
        return slice.inProgressCandidates;
      case 'COMPLETED':
        return slice.completedCandidates;
      default:
        return [];
    }
  });
  const totalCount = useSelector(
    (state) => state.interviewManagementSlice.totalCount,
  );

  // ADD this before the return:

  // =============================================================================================

  const allJobs = useSelector(
    (state) => state.interviewManagementSlice.jobroles,
  );
  const isCandidateLoading = useSelector(
    (state) => state.interviewManagementSlice.loading,
  );

  const menuRef = useRef(null);
  const activeSubSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubSubTab,
  );
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [lockModalOpen, setLockModalOpen] = useState(false);
  const isNavigatingToEvaluation = useRef(false);

  // A report is locked when the completed interview exceeded the plan's paid limit.
  const isReportLocked = (candidate) => !!candidate?.report_locked;
  const LOCKED_REPORT_MESSAGE =
    "This interview report is locked because your completed interviews exceeded your plan limit. Upgrade to unlock it.";
  const [showReasonModel, setShowReasonModel] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const applyNow = useSelector((state) => state.filterSlice.applyNow);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const portal = location.pathname.startsWith('/hr') ? 'hr' : 'org-admin';
  const currentCols = useSelector(
    (state) => state.filterSlice.columnVisibility?.[activeTab]?.[activeSubTab],
  );
  const selectAllClicked = useSelector(
    (state) => state.candidateManagementSlice.selectAllClicked,
  );
  const org_id = useSelector((state) => state.userSlice.org_id);
  // console.log(
  //   '--------------------------------------------------------------------',
  // );
  // console.log('ORG ID IN TABLE:', org_id);
  // console.log(
  //   '--------------------------------------------------------------------',
  // );
  const visibleColumns = useMemo(() => {
    return currentCols.reduce((acc, col) => {
      const key = Object.keys(col)[0];
      acc[key] = col[key];
      return acc;
    }, {});
  }, [currentCols]);

  const [currentPage, setCurrentPage] = useState(1);
  const [prevActiveSubTabLocal, setPrevActiveSubTabLocal] =
    useState(activeSubTab);

  if (activeSubTab !== prevActiveSubTabLocal) {
    setPrevActiveSubTabLocal(activeSubTab);
    setCurrentPage(1);
  }

  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalCount);
  const displayTotal = totalCount;

  const paginatedCandidates = candidates;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage]);

  const interviewParams = useMemo(() => {
    return buildInterviewThunkParams({
      filterState,
      activeSubTab,
      page: currentPage,
      limit: itemsPerPage,
      org_id,
      isInvitedDateVisible: visibleColumns['Invited Date'],
    });
  }, [
    filterState.dateRange,
    filterState.currentJobRole,
    filterState.currentOwner,
    filterState.currentScoreRange,
    filterState.scheduledStatusFilter,
    filterState.searchQuery,
    itemsPerPage,
    currentPage,
    activeSubTab, // Add activeSubTab
    org_id,
    visibleColumns,
  ]);
  // console.log({ org_id });
  const [debouncedParams, setDebouncedParams] = useState(interviewParams);
  const [syncedParamsString, setSyncedParamsString] = useState(null);

  const prevSearchRef = useRef(filterState.searchQuery);

  useEffect(() => {
    const isSearchChange = prevSearchRef.current !== filterState.searchQuery;
    prevSearchRef.current = filterState.searchQuery;

    if (!isSearchChange) {
      setDebouncedParams(interviewParams);
      return;
    }

    const timer = setTimeout(() => {
      setDebouncedParams(interviewParams);
    }, 700);
    return () => clearTimeout(timer);
  }, [interviewParams, filterState.searchQuery]);

  useEffect(() => {
    if (isNavigatingToEvaluation.current) return;

    let promise;
    let isAborted = false;

    if (org_id) {
      const currentParamStr = JSON.stringify(debouncedParams);
      promise = dispatch(getAllCandidatesForInterviewThunk(debouncedParams));

      promise.finally(() => {
        if (!isAborted) {
          setSyncedParamsString(currentParamStr);
        }
      });
    }

    return () => {
      isAborted = true;
      if (promise) {
        promise.abort();
      }
    };
  }, [debouncedParams, dispatch, org_id]);

  // Effect: Clean up applyNow after fetch (it's a trigger)
  useEffect(() => {
    if (!applyNow || activeTab !== 'INTERVIEW') return;
    setCurrentPage(1);
    dispatch(resetApplyNow());
  }, [applyNow, activeTab, dispatch]);

  // Reset to page 1 whenever any filter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [
    filterState.dateRange,
    filterState.currentJobRole,
    filterState.currentOwner,
    filterState.currentScoreRange,
    filterState.scheduledStatusFilter,
    filterState.searchQuery,
  ]);

  // Effect: Initial job roles fetch
  useEffect(() => {
    if (allJobs.length === 0) {
      dispatch(getJobPositionsThunk());
    }
  }, [dispatch, allJobs.length]);

  const handleUnselectAllCandidates = () => {
    dispatch(
      unselectAllCandidatesReducer({
        activeSubTab,
        activeSubSubTab,
        candidates,
      }),
    );
    dispatch(
      selectAllCandidateFromInterViewList({
        value: false,
        combined_status: activeSubTab,
      }),
    );
  };
  useEffect(() => {
    handleUnselectAllCandidates();
  }, [activeSubTab, activeSubSubTab]);

  const onViewCandidate = (interview_id, candidate) => {
    dispatch(setCandidateForReport(candidate));
    isNavigatingToEvaluation.current = true;
    sessionStorage.setItem('returnedFromEvaluation', 'true');
    const basePath = portal === 'hr' ? '/hr' : '/org-admin';
    navigate(`${basePath}/evaluationpage/${interview_id}`, {
      state: {
        interview_id,
        page: currentPage,
        candidate: candidate,
      },
    });
  };
  const handleSort = (key) => {
    // Read directly from Redux state snapshot
    const currentKey = sortConfig.key;
    const currentDir = sortConfig.direction;
    console.log({ currentDir, currentKey });
    let newDirection;

    if (currentKey !== key) {
      // New column clicked — start fresh with asc
      newDirection = 'asc';
    } else if (currentDir === 'asc') {
      newDirection = 'desc';
    } else if (currentDir === 'desc') {
      newDirection = null;
    } else {
      // was null, restart
      newDirection = 'asc';
    }

    dispatch(sortInterviewColByDir({ key, direction: newDirection }));
  };

  const isDataSynced = syncedParamsString === JSON.stringify(interviewParams);

  if (isCandidateLoading || !isDataSynced) {
    return (
      <div className="w-full h-[70vh] flex flex-row items-center justify-center">
        <Loader />
      </div>
    );
  }

  const menuItems = {
    ALL: ['Select', 'Reject', 'Reschedule', 'Cancel', 'View Report'],
    SCHEDULED: ['Reschedule', 'Cancel', 'View Report'],
    PROGRESS: ['Reschedule', 'Cancel', 'View Report'],
    COMPLETED: ['Select', 'Reject', 'View Report'],
  };

  const getDisplayStatus = (candidate) => {
    if (candidate?.combined_status === 'Completed') return 'Completed';
    if (candidate?.combined_status === 'In Progress') return 'In Progress';
    if (candidate?.canceledByCandidate) return 'Cancelled - Candidate';
    if (candidate?.isCanceled) return 'Cancelled - HR';
    if (candidate?.combined_status === 'Cancelled - System')
      return 'Cancelled - System';
    if (candidate?.isRescheduled) return 'Rescheduled';
    return candidate?.combined_status || 'N/A';
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Completed':
        return 'text-[#34B53A]';
      case 'In Progress':
        return 'text-[#FFB200]';
      case 'Pending':
        return 'text-[#9E9E9E]';
      case 'Rescheduled':
        return 'text-[#FFB200]'; // blue/purple
      case 'Cancelled - HR':
      case 'Cancelled - Candidate':
      case 'Cancelled - System':
        return 'text-[#DC0000]'; // red
      default:
        return 'text-[#D9D9D9]';
    }
  };

  const handleupdateCandidateStatus = async (
    candidate,
    status,
    reason = '',
  ) => {
    console.log({ candidate });
    setOpenMenuIndex(null);
    if (status === 'REJECTED' && reason.trim() === '') {
      toast.error('Please provide a reason for rejection');
      return;
    }
    const toastId = toast.loading(
      status === 'SELECTED'
        ? 'Marking candidate as selected...'
        : 'Marking candidate as rejected...',
    );
    const response = await updateCandidateStatusService({
      interview_id: candidate?._id,
      status,
      reason: reason,
      candidate_name: candidate?.candidate_name,
      candidate_email: candidate?.candidate_email,
      candidate_number:
        candidate?.contact_number != null
          ? String(candidate.contact_number)
          : '',
      hr_owner: candidate?.scheduled_by_name,
      date_of_interview: candidate?.invited_date,
      interview_score:
        candidate?.interview_percent != null
          ? String(candidate.interview_percent)
          : 'NA',
      job_role: candidate?.jdposition,
    });

    const { success, data } = response;
    if (success && status === 'SELECTED') {
      toast.update(toastId, {
        render: 'Candidate Marked as Selected',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
      dispatch(updateCandidateStatus({ candidate }));
      dispatch(addCandidateToShortListedList(data));
      return;
    }
    if (success && status === 'REJECTED') {
      toast.update(toastId, {
        render: 'Candidate Marked as Rejected',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
      dispatch(updateCandidateStatus({ candidate }));
      dispatch(addCandidateToRejectedList(data));
    }

    setOpenMenuIndex(null);
  };

  const handleSelectAllCandidates = async (value) => {
    console.log({ paginatedCandidates });
    dispatch(
      updateSelectAllCandidateReducer({
        activeTab,
        activeSubSubTab: '',
        activeSubTab,
        value,
        candidates: paginatedCandidates,
      }),
    );
    dispatch(
      selectAllCandidateFromInterViewList({
        value,
        combined_status: activeSubTab,
      }),
    );
  };

  const handletoggleCandidateStatus = (candidate) => {
    console.log({ candidate });
    dispatch(addcandidateToSelectedList(candidate));
    dispatch(selectCandidateFromInterViewList(candidate));
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    dispatch(toggleSelectAllState(false));
    setCurrentPage(page);
  };

  const handleCancelCandidate = async (candidate) => {
    setOpenMenuIndex(null);
    const toastId = toast.loading('Processing Please Wait');
    const plainCandidate = JSON.parse(JSON.stringify(candidate));
    const rep = await deleteInterviewCandidateDataService(
      plainCandidate?.interview_id,
    );

    if (rep) {
      console.log({ candidate });
      dispatch(removeCandidateFromInterviewLists(plainCandidate?.interview_id));
      toast.update(toastId, {
        render: 'Interview cancelled successfully',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } else {
      toast.update(toastId, {
        render: 'Something went wrong while cancelling the candidate interview',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleCloseSchedulePopup = (val) => {
    dispatch(toggleSchedulePopupState());
  };

  const handleReScheduleInterviewForCandidates = async (providedRange) => {
    const rangeToUse = providedRange || interviewDateRange;
    if (!rangeToUse || rangeToUse.length < 2 || !rangeToUse[0]) return;

    const toastId = toast.loading('Processing ');
    const startDate = new Date(rangeToUse[0]).toISOString();
    const endDate = new Date(rangeToUse[1]).toISOString();

    const resp = await reSchedulecandidateInterviewService(
      selectedCandidate.interview_id,
      startDate,
      startDate,
      endDate,
    );
    if (resp) {
      // dispatch(getAllCandidatesForInterviewThunk(interviewParams));
      dispatch(reSchedulecandidateInterview(selectedCandidate));
      toast.update(toastId, {
        render: 'Rescheduled',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } else {
      toast.update(toastId, {
        render: 'Something Went Wrong',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
    // dispatch(toggleSchedulePopupState());
    setInterviewDateRange([]);
    setSelectedCandidate(null);
  };

  const SortIcon = ({ colKey }) => {
    const className =
      'w-4 h-4 cursor-pointer dark:hover:text-white hover:text-gray-300';

    if (sortConfig.key !== colKey)
      return <ArrowUpDown className={`${className} opacity-40`} />;
    if (sortConfig.direction === 'asc')
      return <ArrowUpAZ className={className} />;
    if (sortConfig.direction === 'desc')
      return <ArrowDownZA className={className} />;

    return <ArrowUpDown className={`${className} opacity-40`} />; // direction is null
  };

  const getMenuItemsForCandidate = (candidate) => {
    const status = getDisplayStatus(candidate);

    let items;
    if (activeSubTab !== 'ALL') {
      items = menuItems[activeSubTab];
    } else {
      switch (status) {
        case 'Completed':
          items = ['Select', 'Reject', 'View Report'];
          break;
        case 'Pending':
        case 'In Progress':
          items = ['Reschedule', 'Cancel', 'View Report'];
          break;
        case 'Rescheduled':
        case 'Cancelled - HR':
        case 'Cancelled - Candidate':
        case 'Cancelled - System':
          items = ['Reschedule', 'Cancel', 'View Report'];
          break;
        default:
          items = ['Reschedule', 'Cancel', 'View Report'];
      }
    }

    // Remove 'Cancel' option if candidate is already canceled
    const blockList = [
      'Cancelled - HR',
      'Cancelled - Candidate',
      'Cancelled - System',
    ];
    if (blockList.includes(status)) {
      items = items.filter((item) => item !== 'Cancel');
    }

    return items;
  };

  return (
    <div className="flex flex-1 flex-col w-full h-full mt-4">
      <div
        className="flex-1 "
        // style={{ maxHeight: 'calc(100vh - 280px)' }}
      >
        <style>{`
    ::-webkit-scrollbar { width: 4px; height: 4px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: rgb(250, 250, 250, 0.6); border-radius: 100px; }
    ::-webkit-scrollbar-thumb:hover { background: rgb(255, 255, 255, 0.9); }
    ::-webkit-scrollbar-corner { background: transparent; }
    * { scrollbar-width: thin; scrollbar-color: rgb(250, 250, 250, 0.6) transparent; }
  `}</style>
        <table className="relative  w-full  table-fixed">
          <thead className=" z-10 bg-bgSecondary ">
            <tr className="border-b border-[#5A4479D4]">
              <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary w-12 py-4">
                {totalCount > 0 && (
                  <input
                    type="checkbox"
                    className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600"
                    checked={selectAllClicked}
                    onChange={(e) => {
                      handleSelectAllCandidates(e.target.checked);
                    }}
                    title="Select All"
                  />
                )}
              </th>
              {visibleColumns['Candidate Name'] && (
                <th
                  className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative"
                  onClick={() => handleSort('candidate_name')}
                >
                  <div className="flex items-center gap-6">
                    Candidate Name
                    <SortIcon colKey="candidate_name" />
                  </div>
                </th>
              )}
              {visibleColumns['Job Role'] && (
                <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative">
                  Job Role
                </th>
              )}
              {visibleColumns['Email Id'] && (
                <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative">
                  Email ID
                </th>
              )}
              {visibleColumns['Contact Number'] && (
                <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative">
                  Contact Number
                </th>
              )}
              {visibleColumns['Invited Date'] && (
                <th
                  className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative"
                  onClick={() => handleSort('invited_date')}
                >
                  <div className="flex items-center gap-5 justify-start">
                    Invited Date
                    <SortIcon colKey="invited_date" />
                  </div>
                </th>
              )}
              {visibleColumns['End Date'] && (
                <th
                  className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative"
                  onClick={() => handleSort('end_date')}
                >
                  <div className="flex items-center gap-5 justify-start">
                    End Date
                    <SortIcon colKey="end_date" />
                  </div>
                </th>
              )}
              {visibleColumns['Owner'] && (
                <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative">
                  Owner
                </th>
              )}
              {visibleColumns['Interview Score'] && (
                <th
                  className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative"
                  onClick={() => handleSort('interview_percent')}
                >
                  <div className="flex items-center gap-5 justify-start">
                    Interview Score
                    <SortIcon colKey="interview_percent" />
                  </div>
                </th>
              )}
              {visibleColumns['Status'] && (
                <th className="text-left text-xs dark:text-[#D8D8D8] text-textPrimary font-medium py-4  w-[8rem]  ">
                  Status
                </th>
              )}
              {activeSubTab != 'PROGRESS' && <th className="w-10"> </th>}
            </tr>
          </thead>
          <tbody>
            {paginatedCandidates.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <div className="flex h-[30vh] items-center justify-center">
                    <div className="flex flex-col items-center text-center">
                      <h2 className="text-lg font-medium text-gray-400 mb-1">
                        No candidates found
                      </h2>
                      <p className="text-sm text-gray-400">
                        Try adjusting your filters or search terms to see more
                        results.
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            )}
            {paginatedCandidates &&
              paginatedCandidates.length > 0 &&
              paginatedCandidates.map((candidate, index) => (
                <tr
                  key={index}
                  className="cursor-pointer border-b dark:border-gray-700/30 border-gray-300/30 dark:hover:bg-gray-700/20 hover:bg-gray-100 transition-colors "
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isReportLocked(candidate)) {
                      setLockModalOpen(true);
                      return;
                    }
                    onViewCandidate(candidate?._id, candidate);
                  }}
                >
                  <td
                    className="p-4"
                    onClick={() => {
                      if (isReportLocked(candidate)) return;
                      handletoggleCandidateStatus(candidate);
                    }}
                  >
                    <input
                      type="checkbox"
                      className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600 disabled:opacity-40 disabled:cursor-not-allowed"
                      checked={candidate.isSelected || false}
                      disabled={isReportLocked(candidate)}
                      onClick={(e) => {
                        e.stopPropagation(); // ✅ THIS is critical
                      }}
                      onChange={() => {
                        if (isReportLocked(candidate)) return;
                        handletoggleCandidateStatus(candidate);
                      }}
                    />
                  </td>
                  {visibleColumns['Candidate Name'] && (
                    <td className="py-4   dark:text-[#CCCCCCE5] text-textSecondary font-medium px-4 text-sm w-48 truncate text-left">
                      <span className="flex items-center gap-1.5">
                        {isReportLocked(candidate) && (
                          <Lock
                            className="w-3.5 h-3.5 text-purple-500 shrink-0"
                            aria-label="Report locked"
                          />
                        )}
                        <span className="truncate">{candidate?.candidate_name || 'N/A'}</span>
                      </span>
                    </td>
                  )}
                  {visibleColumns['Job Role'] && (
                    <td className="py-4 px-4  dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {candidate.jdposition || 'N/A'}
                    </td>
                  )}
                  {visibleColumns['Email Id'] && (
                    <td className="py-4 px-4  dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {candidate.candidate_email || 'N/A'}
                    </td>
                  )}
                  {visibleColumns['Contact Number'] && (
                    <td className="py-4 px-4   dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {candidate.contact_number || 'N/A'}
                    </td>
                  )}

                  {visibleColumns['Invited Date'] && (
                    <td className="py-4 px-4  dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {candidate.invited_date || 'N/A'}
                    </td>
                  )}
                  {visibleColumns['End Date'] && (
                    <td className="py-4 px-4  dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {formatDateOnly(candidate.end_date) || 'N/A'}
                    </td>
                  )}
                  {visibleColumns['Owner'] && (
                    <td className="py-4 px-4  dark:text-[#CCCCCCE5] text-textSecondary text-sm w-48 truncate text-left">
                      {candidate.scheduled_by_name || 'N/A'}
                    </td>
                  )}
                  {visibleColumns['Interview Score'] && (
                    <td className=" text-sm text-[#CCCCCC] text-center align-middle pl-4 py-3  ">
                      {isReportLocked(candidate) ? (
                        // Locked: hide the score entirely (neutral border so the
                        // colour band doesn't leak the result) and blur the value.
                        <div className="flex items-center justify-center border border-transparent w-9 p-0.5 px-5 rounded-lg text-[#CCCCCC]">
                          <span
                            className="px-1 mx-1 blur-sm select-none"
                            aria-hidden="true"
                          >
                            88.8
                          </span>
                        </div>
                      ) : (
                        <div
                          className={`flex items-center   justify-center border w-9 p-0.5 px-5 rounded-lg ${
                            candidate.interview_percent >= 70
                              ? 'border-green-600 text-green-400'
                              : candidate.interview_percent >= 30
                                ? 'border-yellow-600 text-yellow-400'
                                : candidate.interview_percent != 'NA'
                                  ? 'border-red-600 text-red-400'
                                  : 'border-transparent text-[#CCCCCC]'
                          }`}
                        >
                          <span className="px-1 mx-1">
                            {isNaN(candidate.interview_percent) ||
                            candidate.interview_percent === 'NA'
                              ? '-'
                              : Number(candidate.interview_percent).toFixed(1)}
                          </span>
                        </div>
                      )}
                    </td>
                  )}
                  {visibleColumns['Status'] && (
                    <td
                      className={`py-4 px-0 font-medium text-left text-sm truncate max-w-[7.5rem] ${getStatusColor(getDisplayStatus(candidate))}  `}
                      title={getDisplayStatus(candidate)}
                    >
                      {getDisplayStatus(candidate)}
                    </td>
                  )}
                  {(activeSubTab != 'PROGRESS' || activeSubTab === 'ALL') && (
                    <td className="w-10   mt-4 ml-1">
                      <EllipsisVertical
                        className={`${
                          candidate.isCanceled && false
                            ? 'text-gray-300 cursor-not-allowed opacity-40'
                            : 'text-gray-400 cursor-pointer'
                        }`}
                        onClick={(e) => {
                          // if (candidate.isCanceled) return; // ✅ block menu open if cancelled
                          e.stopPropagation();
                          if (isReportLocked(candidate)) {
                            setLockModalOpen(true);
                            return;
                          }
                          setOpenMenuIndex(index);
                        }}
                      />
                      {openMenuIndex === index && !isReportLocked(candidate) && (
                        <div
                          className="absolute right-12 dark:bg-gray-800 bg-white w-[130px] border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl py-1 z-50"
                          ref={menuRef}
                        >
                          {getMenuItemsForCandidate(candidate)?.map((item) => (
                            <button
                              key={item}
                              className="w-full text-left text-sm px-3 py-2
                            dark:text-gray-300 text-gray-700
                            dark:hover:bg-gray-700 hover:bg-gray-100
                            dark:hover:text-white hover:text-gray-900
                            transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  item === 'Select' &&
                                  (activeSubTab === 'COMPLETED' ||
                                    activeSubTab === 'ALL')
                                ) {
                                  handleupdateCandidateStatus(
                                    candidate,
                                    'SELECTED',
                                  );
                                }
                                if (item === 'Reschedule') {
                                  setSelectedCandidate(candidate);
                                  dispatch(toggleSchedulePopupState());
                                }
                                if (item === 'Reject') {
                                  setShowReasonModel(true);
                                  setSelectedCandidate(candidate);
                                }
                                if (item === 'Cancel') {
                                  setOpenMenuIndex(null);
                                  setSelectedCandidate(candidate);
                                  setShowCancelPopup(true);
                                }
                                if (item === 'View Report') {
                                  setOpenMenuIndex(null);
                                  onViewCandidate(candidate?._id, candidate);
                                }
                              }}
                            >
                              {item}
                            </button>
                          ))}
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
          {showReasonModel && (
            <ConfirmationDialog
              open={showReasonModel}
              onClose={() => setShowReasonModel(false)}
              title="Tell Us Reason for Rejecting Candidate"
              message={`Are you sure you want to Reject candidate ?`}
              confirmText="Reject"
              cancelText="Cancel"
              takeReason={true}
              onConfirm={(reasonText) => {
                setShowReasonModel(false);
                handleupdateCandidateStatus(
                  selectedCandidate,
                  'REJECTED',
                  reasonText,
                );
              }}
            />
          )}
          {showCancelPopup && (
            <ConfirmationDialog
              open={showCancelPopup}
              onClose={() => setShowCancelPopup(false)}
              title="Confirm Cancellation"
              message="Are you sure you want to cancel this candidate's interview?"
              confirmText="Cancel Interview"
              cancelText="Go Back"
              takeReason={false}
              onConfirm={() => {
                setShowCancelPopup(false);
                handleCancelCandidate(selectedCandidate);
              }}
            />
          )}
        </table>
      </div>
      <LimitExceededModal
        isOpen={lockModalOpen}
        onClose={() => setLockModalOpen(false)}
        featureKey="interview_count"
        errorCode="FEATURE_LOCKED"
        message={LOCKED_REPORT_MESSAGE}
      />
      <div className="pt-8">
      <Pagination
        currentPage={currentPage}
        totalItems={totalCount}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        onItemsPerPageChange={(size) => {
          setItemsPerPage(size);
          setCurrentPage(1);
        }}
        label="Candidates"
      />
      </div>
      {showReasonModel && (
        <ConfirmationDialog
          open={showReasonModel}
          onClose={() => setShowReasonModel(false)}
          title="Tell Us Reason for Rejecting Candidate"
          message={`Are you sure you want to Reject candidate ?`}
          confirmText="Reject"
          cancelText="Cancel"
          takeReason={true}
          onConfirm={(reasonText) => {
            setShowReasonModel(false);
            handleupdateCandidateStatus(
              selectedCandidate,
              'REJECTED',
              reasonText,
            );
          }}
        />
      )}
      <ScheduleInterviewDialog
        isSchedulePopupOpen={isSchedulePopupOpen}
        toggleSchedulePopup={(val) => {
          handleCloseSchedulePopup(val);
          if (!val) setSelectedCandidate(null);
        }}
        setDateRange={setInterviewDateRange}
        dateRange={interviewDateRange}
        handleScheduleInterviewForCandidates={
          handleReScheduleInterviewForCandidates
        }
        isReschedule={!!selectedCandidate}
        existingStartDate={selectedCandidate?.start_date || 'N/A'}
        existingEndDate={selectedCandidate?.end_date || 'N/A'}
      />
    </div>
  );
}

export default InterviewManagementTable;
